import { inject, Service } from '@angular/core'
import { InAppReview } from '@capacitor-community/in-app-review'
import { Platform } from '@ionic/angular'
import { FirebaseAnalyticsService } from './firebase-analytics.service'
import { Capacitor } from '@capacitor/core'

@Service()
export class RateService {
  private firebaseAnalyticsService = inject(FirebaseAnalyticsService)
  private platform = inject(Platform)

  init() {
    setTimeout(async () => {
      await this.platform.ready()
      if (Capacitor.isNativePlatform()) {
        await InAppReview.requestReview()
        const platforms = this.platform.platforms().join('-')
        await this.firebaseAnalyticsService.trackEvent('rating_popup', { platforms })
      }
    }, 10 * 1000)
  }
}
